import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_347: DocMigration = {
  maxSchemaVersion: "0.0.347",
  description:
    "Remove 'TOP_DOWN' & 'PLAN' reference frame from non-elevation annotation & rename elevation reference frames",
  apply(json: any) {
    for (const id in json.annotation) {
      delete json.annotation[id].referenceFrame;
    }

    // Rename viewTemplate.elevationDirection to viewTemplate.referenceFrame
    for (const id in json.viewTemplates) {
      const viewTemplate = json.viewTemplates[id];

      if (viewTemplate.elevationDirection) {
        viewTemplate.referenceFrame = viewTemplate.elevationDirection;
        delete viewTemplate.elevationDirection;
      }
    }

    return json;
  },
};

export default migration_0_0_347;
